import React from 'react';
import { Panel, PanelTheme } from '../Panel';
import { ProgressSpinner } from '../ProgressSpinner';

export const ProgressSpinnerDemo: React.FC = () => {
    return (
        <div style={{ maxWidth: '500px' }}>
            <div style={{ marginTop: '0px', marginBottom: '20px' }}>
                <h2>Progress Spinner :</h2>
                <br />
                <br />
                <Panel
                    theme={PanelTheme.White}
                    width='88%'
                >
                    <ProgressSpinner />
                </Panel>
            </div>
        </div>
    );
};
